import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { IntegrationManagementActionsState } from '../reducers/integration-management-actions.reducer';
import * as selectors from '../selectors/intgration-management-actions.selectors';

@Injectable()
export class IntegrationManagementActionsFacadeService extends FacadeService {
  constructor(public override store: Store<IntegrationManagementActionsState>) {
    super(store);
  }

  // OBSERVABLES

  showDeleteRowConfirmText$ = this.storeSelect(selectors.getShowDeleteRowConfirmTextValue);
  showDeactivateStatusRowConfirmText$ = this.storeSelect(
    selectors.getShowDeactivateStatusRowConfirmTextValue,
  );
  selectedIntegrationRowData$ = this.storeSelect(selectors.getSelectedIntegrationRowData);
  selectedIntegrationCode$ = this.storeSelect(selectors.getSelectedIntegrationCode);
  sidenavStatus$ = this.storeSelect(selectors.getSidenavStatus);
  updateBtnEnabled$ = this.storeSelect(selectors.getUpdateBtnEnabled);
  deleteBtnEnabled$ = this.storeSelect(selectors.getDeleteBtnEnabled);
  isIntegrationSystemValidForEdit$ = this.storeSelect(selectors.getIsIntegrationSystemValidForEdit);
  showEditBtn$ = this.storeSelect(selectors.getShowEditBtn);

  // OBSERVABLE'S VALUES

  get showDeleteRowConfirmText() {
    return this.storeSnapshot(this.showDeleteRowConfirmText$);
  }

  get showDeactivateStatusRowConfirmText() {
    return this.storeSnapshot(this.showDeactivateStatusRowConfirmText$);
  }

  get selectedIntegrationRowData() {
    return this.storeSnapshot(this.selectedIntegrationRowData$);
  }

  get selectedIntegrationCode() {
    return this.storeSnapshot(this.selectedIntegrationCode$);
  }

  get showEditBtn() {
    return this.storeSnapshot(this.showEditBtn$);
  }
}
